module.exports = __webpack_public_path__ + "img/01.a1dc3d8a.png";